import { useEffect, useState } from 'react';

export default function SlotItem({ image, gender, skin, slot, url, active, onClick }) {
    const [ loading, setLoading ] = useState(false);

    useEffect(() => {
        const loader = window.avatarLoader;

        const evtLoading = loader.on(`loading:${slot}:${url}.glb`, () => {
            setLoading(true);
        });

        const evtLoaded = loader.on(`loaded:${slot}:${url}.glb`, () => {
            setLoading(false);
        });

        if (loader.loading.has(slot) && loader.loading.get(slot).indexOf(url + '.glb') !== -1) {
            setLoading(true);
        }

        return () => {
            evtLoading.off();
            evtLoaded.off();
        };
    }, []);

    return (
        <li className={(active?'active ':'') + (loading?'loading ':'')} data-gender={gender ?? null} data-skin={skin ?? null} onClick={onClick}>
            <img src={image} loading='lazy' draggable='false' />
        </li>
    );
}
